export enum UserEntityPermissionsType {
    Projects,
    UserInvitations,
    Companies,
    Associations,
    Businesses,
    References,
    BusinessOrders,
    BusinessProspects,
    BusinessBookingRequests,
    BusinessContacts,
    Campaigns
}

export enum UserPermissionAction {
    Owner = 'manage',
    Read = 'read',
    DirectRead = 'directRead',
    Write = 'write',
}

export class UserEntityPermissions {
    public entity?: UserEntityPermissionsType;
    public owner: number[] = [];
    public read: number[] = [];
    public directRead: number[] = [];
    public write: number[] = [];

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, { entity: UserEntityPermissionsType[json.entity] });
    }
}
